// extracted by mini-css-extract-plugin
export default {"noticeContainer":"InfoNotice_noticeContainer__2VT8X","noticeIcon":"InfoNotice_noticeIcon__P8NUV"};